export const SCROLL_WIDTH = 13;
export const SELECT_OPTIONS_HEIGHT_PAGINATION = 230;
export const SELECT_OPTIONS_HEIGHT = 182;
export const MAX_OPTIONS_WITHOUT_SCROLL = 5;
export const SEARCH_HEIGHT = 48;
export const ITEM_HEIGHT = 34.2;
export const SPARE_VISIBILITY = 3;
